























import { Component, Vue, Prop } from "vue-property-decorator";
import EventBus from "../event-bus";

@Component
export default class OperatorList extends Vue {
  operatorList: Array<any> = [];
  selected_operator: number = 0;

  @Prop()
  emergency: any;

  beforeMount() {
    this.$http.get("/emma/admin/operator-list").then(resp => {
      this.operatorList = resp.data;
    });
  }

  openChat(operator: any) {
    EventBus.$emit("open-chat", operator, this.emergency);
    this.selected_operator = operator.id;
  }
}
